import React from 'react';
import styled from 'styled-components';

const Foot = styled.footer`
  padding: 1.5rem 2.5rem;
  background: var(--black);
`;

const Inner = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.25rem;
  }
`;

const Text = styled.span`
  font-size: 0.7rem;
  color: var(--gray-3);
  font-weight: 300;
`;

const Footer = () => (
  <Foot>
    <Inner>
      <Text>&copy; 2026 Andreassen Kapital AS</Text>
      <Text>Bergen, Norge</Text>
    </Inner>
  </Foot>
);

export default Footer;
